import { Notifications } from "./types";

export enum NotificationsActionTypes {
  CLEAR_NOTIFICATION_MESSAGE = '@@notifications/CLEAR_NOTIFICATION_MESSAGE',
  ADD_NOTIFICATION_MESSAGE = '@@notifications/ADD_NOTIFICATION_MESSAGE'
}

interface IClearNotificationMessage {
  type: typeof NotificationsActionTypes.CLEAR_NOTIFICATION_MESSAGE;
}

interface IAddNotificationMessage {
  type: typeof NotificationsActionTypes.ADD_NOTIFICATION_MESSAGE;
  notification: Notifications;
}

export type NotificationsActions =
  | IClearNotificationMessage
  | IAddNotificationMessage;
